import { Button, Divider, List, ListSubheader, Typography, FormControlLabel, Checkbox } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import { createStyles, makeStyles } from '@material-ui/styles';
import { MobilePageDefinition } from '../services';
import React, { FC, useContext, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { FormContext } from '..';
import { AppState } from '../../../../redux';
import { getFullFormVersion } from '../../NewEvalButton';
import { TableOfContentsPage } from './TableOfContentsPage';

interface TableOfContentsProps {
  pages: readonly {definition: MobilePageDefinition, index: number, isVisible: boolean}[];
  currentPage: number;
  currentCard: number;
  onPageSelected: (page: number) => void;
  onCardSelected: (card: number) => void;
}

const useStyles = makeStyles(function (theme: Theme) {
  return createStyles({
    toc: {
      flex: 1,
      padding: theme.spacing(0, 2),
      overflowY: "scroll",
      WebkitOverflowScrolling: "touch",
    },
    tocHeader: {
      width: "100%",
      position: "sticky",
      backgroundColor: theme.palette.background.paper,
      padding: 0,
      flex: 1,
      display: 'flex'
    },
    label: {
      fontSize: '0.8rem',
      marginLeft: 0
    },
    labelWrapper: {
      paddingLeft: '1rem'
    },
    tocHeaderContent: {
      flex: 1
    },
    tocHeaderTitleDeskAudit: {
      paddingLeft: '1rem',
      fontSize: '0.8rem',
      lineHeight: 'normal',
      marginBottom: '0px'
    },
    tocHeaderTitle: {
      paddingLeft: '1rem',
      fontSize: '0.8rem',
      lineHeight: 'normal'
    },
    deskAuditButton: {
      textTransform: "none",
      minWidth: '108px'
    },
  });
});

const selectActiveDefinition = createSelector(
  (state: AppState) => state.forms.activeFormDefinition, definition => definition
)

// better to use state and a reducer?
// with state and reducer, can access inside the appoverlay
export const TableOfContents: FC<TableOfContentsProps> = function (props) {
  const { pages, currentPage, onPageSelected, onCardSelected } = props;
  const classes = useStyles({});
  const { form, toggleDeskAudit, isDeskAudit } = useContext(FormContext);

  const activeDefinition = useSelector(selectActiveDefinition, shallowEqual);

  useEffect(function correctInvalidPge() {
    // If the default page is no longer valid, go to the first valid page
    if (!pages[currentPage].isVisible) {
      props.onPageSelected(pages.find(def => def.isVisible)?.index || 0);
    }
  }, []);

  return <List
      component = { "nav" }
      className = { classes.toc }
      subheader = {
        <ListSubheader component = { "div" } className = { classes.tocHeader }>
          <div className = { classes.tocHeaderContent }>
            <p className={activeDefinition && activeDefinition.desk_audit ? classes.tocHeaderTitleDeskAudit : classes.tocHeaderTitle }>
              { form.short_title } { getFullFormVersion(form) }
            </p>
            {activeDefinition && activeDefinition.desk_audit && (
              <FormControlLabel
                checked={ isDeskAudit }
                classes={{
                    root: classes.labelWrapper,
                    label: classes.label,
                }}
                control={<Checkbox color="primary" onClick={ toggleDeskAudit }/>}
                label="Desk Evaluation"
                labelPlacement="end"
              />
            )}
          </div>
          <Divider variant={"fullWidth"}></Divider>
        </ListSubheader>
      }>
          { pages.map((desc, index) => desc.isVisible
              ? <TableOfContentsPage
                  key = { index }
                  desc = { desc }
                  index = { index }
                  onPageSelected = { onPageSelected }
                  onCardSelected = { onCardSelected }
                  currentPage = { currentPage === index }>
                </TableOfContentsPage>
              : null
          )}
        </List>
  ;
};